import axios from '../../config/axios';


function newPolicy(data) {
    return axios().post("/insurance/policies", data);
}

function getVehicleSupplementaryPolicy(vehicleId) {
    return axios().get("/insurance/vehicle-supplementary", {
        params: {
            vehicle_id: vehicleId
        }
    })
}

function cancel(insuranceId) {
    return axios().put(`/insurance/policies/${insuranceId}/cancel`)
}

function extend(policyId, data) {
    return axios().put(`/insurance/policies/${policyId}/extend`, data)
}

export default {
    newPolicy,
    getVehicleSupplementaryPolicy,
    cancel,
    extend
}